module.exports = __webpack_public_path__ + "media/images/acuvue_card_2-b0e0c1c2f04c644530222497c471b58c.jpg";